import { ref } from 'vue'
import { apiClient } from '../services/apiClient'
import type { MapPlace } from '../types/map'

export function useGeonymHighlight() {
  const isEnabled = ref(false)
  const places = ref<MapPlace[]>([])
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  const toggle = () => {
    isEnabled.value = !isEnabled.value
    if (!isEnabled.value) places.value = []
  }

  const loadPlaces = async (bookId: number, chapter: number) => {
    isLoading.value = true
    error.value = null
    try {
      places.value = await apiClient.getChapterPlaces(bookId, chapter)
    } catch (err: unknown) {
      error.value = err instanceof Error ? err.message : '無法載入地名資料'
      places.value = []
    } finally {
      isLoading.value = false
    }
  }

  return { isEnabled, places, isLoading, error, toggle, loadPlaces }
}
